// extracted by mini-css-extract-plugin
module.exports = {"Terms":"Terms_Terms__2mYeA","DownloadLink":"Terms_DownloadLink__3OZ67"};